import React from 'react';
import { Col, Row, Image} from 'react-bootstrap';
import { motion } from 'framer-motion';
import img from '../img/New Pics/Optimize-your-shipping-with-smart-loads-geodis-united-states.jpg'
import "./About.css";
import Sidebar from './Sidebar';

// Animation variants for staggered content
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: 'easeOut',
    },
  }),
};

function AboutUs() {
  return (
    <>
    <Image className="fade-in responsive-img" src={img} height={500} width="100%" fluid />
    <div div className="container my-4">      
      <Row>
        <Col xs={12} lg={9}>
          <motion.h1
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            custom={0}
            className='mt-5 pt-4 text-danger'
          >
            About Us
          </motion.h1>

          {[
            `We, Catus Technologies is a fast growing Software Development Company that offers Catus LMS (Logistics Management Software). CATUS Software is designed to gives you a competitive advantage and meet your requirements of activities used in the logistics and freight forwarding industries. CATUS is the effective solution to optimize your business with no room of human mistakes. It helps to increase productivity and generate better profits. Catus is multi-user software and can operate from different location by using a centralized server. It controls your complete business cycle. CATUS provides an extremely unmatched software solution to Logistics and Freight forwarding service provider industries, It includes complete operational and financial accounting.`,
            `CATUS is integrated software solution to manage all business activities that associated with Operational and Financial. It provides a document management with their attachments to shipments. Main purpose of CATUS software is to provide strategic services to customers, along with a powerful management of Information Exchange Systems. We assured Catus serves its purpose, restricts you for doing lots of unnecessary double entries. CATUS helps you to imagine a successful business model that determines how well your business grows. It brings your business to new heights of integration. It allows you to be access your business from almost anywhere via computer.`,
            `You will be probably shocked to see how many hours you was wasting doing work in your existing environment. We pride on our support services which are second to none and the reason that many of our customers either choose us in the first place, or switched to us subsequently.`,
          ].map((text, i) => (
            <motion.p className='fs-6 text-justify'
              key={i}
              initial="hidden"
              animate="visible"
              variants={fadeInUp}
              custom={i + 1}
            >
              {text}
            </motion.p>
          ))}

          <motion.h5
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            custom={4}
            className="mt-4 text-danger"
          >
            Apart from boosting productivity, CATUS can also enhance your business in several other aspects such as:
          </motion.h5>

          <motion.ul className='fs-6 text-justify'
            initial="hidden"
            animate="visible"
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.1,
                  delayChildren: 1,
                },
              },
            }}
          >
            {[
              'Saves Money and Time, Reduce Hassles and Feel free your staff from spreadsheet data retrieval.',
              'Increasing the flexibility of your business and also keeps track of progress in your business.',
              'Easily maintained and Put you at a competitive advantage compared in your business sector.',
              'Increasing the value of your company.',
              'Improving the overall quality of your business.',
              'Improves sales and service. The way your customers experience your business is very important.',
              'Conrol your staff Knowing who made what changes and when, instantly.',
              'Stop finding documents around your workplace.',
              'Provides real time environment.',
            ].map((item, i) => (
              <motion.li className='fs-6 text-justify'
                key={i}
                variants={fadeInUp}
                custom={i + 5}
              >
                {item}
              </motion.li>
            ))}
          </motion.ul>

          <motion.p className='fs-6 text-justify'
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            custom={15}
          >
            Catus Software is a user-friendly application which gives a helping hand to your organisation to manage data, resources, performance, and also manages all the internal task and communication for fruitful result. Its screens are designed to reduce the work load of the user and to allow the company to reduce costs.
          </motion.p>
        </Col>

        {/* Right Column Cards */}
        <Col xs={12} lg={3}>
          <Sidebar/>
        </Col>
      </Row>
    </div>
    </>
    
  );
}

export default AboutUs;
